import React, { useEffect, useMemo, useRef, useState } from "react";
import PropTypes from "prop-types";
import { getHeaderLayout, getLeftHeaderLayout } from "./loader";
import { SearchSelectors, UserContextSelectors } from "../../redux/selectors";
import {
  useHeaderHeightResizeDetector,
  useHeaderWidthResizeDetector
} from "./hooks";
import { useSelector } from "react-redux";
import { DeviceType, IgnoreClickOutsideAttribute } from "../../constants";
import { TrackingInfo as trackingInfo } from "../../components/tracking/TrackingInfoHeader";
import Search from "../../components/Menu/Search/SearchHeaderSection";
import ActionIndicatorContainer from "../../components/ActionIndicatorContainer/ActionIndicatorContainer";
import LastLogin from "../../components/LastLogin";
import styled from "styled-components";
import { device } from "../../devices";
import { Brand } from "../../configurations";
import { BrandUtils } from "../../utils/brandUtils";

const SegmentedHeaderWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: stretch;
`;

const ActionIndicatorWrapper = styled.div`
  z-index: 1;
  @media ${device.desktopScreen} {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding-right: 30px;
  }

  @media ${device.mobileScreen} {
    position: absolute;
    right: 100px;
  }
`;

const Header = () => {
  const headerRef = useRef();
  const brandId = useSelector(UserContextSelectors.brandId);
  const isPC = useSelector(UserContextSelectors.isPC);
  const searchActive = useSelector(SearchSelectors.searchActive);

  const [hasActionIndicator, setHasActionIndicator] = useState(false);

  useEffect(() => {
    const actionIndicatorFlag =
      brandId === Brand.Sport_Com || BrandUtils.isPokerClient();
    setHasActionIndicator(actionIndicatorFlag);
  }, [brandId]);

  const SegmentedHeaderPC = useMemo(
    () => getHeaderLayout(brandId, DeviceType.PC),
    [brandId]
  );
  const SegmentedHeaderMobile = useMemo(
    () => getHeaderLayout(brandId, DeviceType.Mobile),
    [brandId]
  );
  const SegmentedLeftHeader = useMemo(
    () => getLeftHeaderLayout(brandId, DeviceType.PC),
    [brandId]
  );

  useHeaderHeightResizeDetector(headerRef);
  useHeaderWidthResizeDetector(headerRef);

  const customAttributes = useMemo(() => {
    return !isPC ? { [IgnoreClickOutsideAttribute]: "" } : {};
  }, [isPC]);

  return (
    <header className="uc-main-header" {...customAttributes}>
      <div className="headerWrapper" ref={headerRef}>
        {isPC ? (
          <div className="header-left-sect-pc">
            <SegmentedLeftHeader />
            <Search
              ignoreClass="do-not-close-search"
              trackingInfo={trackingInfo}
            />
          </div>
        ) : (
          <>
            <LastLogin />
          </>
        )}
        <SegmentedHeaderWrapper>
          {hasActionIndicator && (
            <ActionIndicatorWrapper>
              <ActionIndicatorContainer />
            </ActionIndicatorWrapper>
          )}
          {isPC ? (
            <SegmentedHeaderPC
              key="SegmentedHeaderPC"
              trackingInfo={trackingInfo}
              searchActive={searchActive}
            />
          ) : (
            <SegmentedHeaderMobile
              key="SegmentedHeaderMobile"
              trackingInfo={trackingInfo}
            />
          )}
        </SegmentedHeaderWrapper>
      </div>
    </header>
  );
};

Header.propTypes = {
  actionIndicator: PropTypes.node
};

export default React.memo(Header);
